import React from 'react'
import { Edit, useForm } from '@refinedev/antd'
import { Form, Input } from 'antd'
import type { Tables } from '@muaa/shared'

type HonorYear = Tables<'honor_years'>

export function HonorYearEdit() {
  const { formProps, saveButtonProps } = useForm<HonorYear>()

  return (
    <Edit saveButtonProps={saveButtonProps}>
      <Form {...formProps} layout="vertical">
        <Form.Item
          label="Year"
          name="year"
          rules={[{ required: true, message: 'Year is required' }]}
        >
          <Input placeholder="e.g. 1991, 1996, 2001" />
        </Form.Item>
      </Form>
    </Edit>
  )
}
